module.exports = __webpack_public_path__ + "ed807f12e1a6bf0dbedd11574ea68142.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/uneven-30.png
// module id = 2330
// module chunks = 0